// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"A3rUCBwLvtQ28kBq"};